const DECIMAL_DISPLAY = 2
const BASE = 10

export function decimalDisplay(price) {
  if (price) {
    const floatPrice = parseFloat(price)
    return parseInt(price, BASE) === price ? floatPrice.toString() : floatPrice.toFixed(DECIMAL_DISPLAY)
  }
  return '0.00'
}

export default decimalDisplay



// WEBPACK FOOTER //
// ./utilities/pricing.js